"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
export const bindActions = function bindActions() {
  $(Dom.tab).on("click", function (event) {
    event.preventDefault();
    handlers.toggleClasses($(this));
  });
  handlers.setFirstActive();
  handlers.setActiveTab();
};
